import React from 'react';

type DisclaimerVariant = 'updates' | 'analysis' | 'chat';

const disclaimerCopy: Record<DisclaimerVariant, { title: string; description: string }> = {
    updates: {
        title: '⚠️ Legal Information Disclaimer',
        description:
            'LRDEnE shares informational updates pulled from public sources. This service does not replace advice from a licensed lawyer, does not establish an attorney-client relationship, and should never be used as the sole basis for legal decisions.',
    },
    analysis: {
        title: '⚠️ AI Document Analysis Disclaimer',
        description:
            'AI-generated document insights highlight potential issues but are not tailored to your specific case. Always validate critical decisions with a qualified lawyer before acting.',
    },
    chat: {
        title: '⚠️ Conversational Assistant Disclaimer',
        description:
            'Chat replies are informational only. They may help you prepare questions or understand terminology, but they are not legal advice and cannot guarantee outcomes.',
    },
};

interface LegalDisclaimerProps {
    variant?: DisclaimerVariant;
    className?: string;
}

export const LegalDisclaimer: React.FC<LegalDisclaimerProps> = ({ variant = 'updates', className }) => {
    const copy = disclaimerCopy[variant] ?? disclaimerCopy.updates;
    return (
        <div
            className={`flex gap-3 rounded-lg border border-yellow-200 dark:border-yellow-800 bg-yellow-50 dark:bg-yellow-900/20 p-4 ${className ?? ''}`}
            role="status"
            aria-live="polite"
        >
            <span className="material-symbols-outlined text-yellow-700 dark:text-yellow-300 flex-shrink-0">gavel</span>
            <div className="text-sm text-yellow-800 dark:text-yellow-100">
                <p className="font-semibold mb-1">{copy.title}</p>
                <p className="text-xs leading-relaxed text-yellow-900/90 dark:text-yellow-100/90">{copy.description}</p>
            </div>
        </div>
    );
};
